export const selectInput = () => ({
    '& .ant-select-selection': {
        minWidth: 90,
    },
});
